"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const consts_1 = require("./consts");
const traps_1 = require("./traps");
/* TRAPS HELPERS */
class TrapsHelpers {
    /* CONSTRUCTOR */
    constructor(object, callback) {
        this.stopped = false;
        this.changed = false;
        this.changedPaths = [];
        this.getPathsRecording = false;
        this.getPaths = [];
        this.paths = new WeakMap();
        this.proxies = new WeakMap();
        this.trapDepth = 0;
        this.object = object;
        this.callback = callback;
        this.traps = this.wrapTraps(traps_1.default);
    }
    /* HELPERS */
    checkChildIsRoot(child) {
        if (child !== this.object)
            return;
        throw new Error(`A reference to the whole watched object has been found at path "${this.paths.get(child)}", this is not supported.`);
    }
    checkChildPathDuplicate(child, childPath) {
        const childPathPrev = this.paths.get(child);
        if (childPath === childPathPrev)
            return;
        if (!childPathPrev || !Object.is(child, childPathPrev.split('.').reduce((acc, key) => acc[key] || {}, this.object)))
            return;
        throw new Error(`Duplicate object encountered, the same object is being referenced both at path "${childPathPrev}" and at path "${childPath}". Duplicate objects in a watched object are not supported.`);
    }
    getChildPath(parent, path) {
        const parentPath = this.getParentPath(parent), childPath = parentPath ? `${parentPath}.${path}` : `${path}`;
        return childPath;
    }
    getParentPath(parent) {
        return this.paths.get(parent) || '';
    }
    setChildPath(parent, child, path) {
        const childPath = this.getChildPath(parent, path);
        if (consts_1.IS_DEVELOPMENT && Object.getPrototypeOf(parent)[path] !== child)
            this.checkChildPathDuplicate(child, childPath);
        this.paths.set(child, childPath);
    }
    triggerChange(result, path) {
        this.changed = true;
        this.changedPaths.push(path);
        return result;
    }
    wrapTrap(trap) {
        const self = this;
        return function trapWrapper() {
            self.trapDepth++;
            const result = trap.apply(self, arguments);
            self.trapDepth--;
            if (!self.trapDepth && self.changed && !self.stopped) {
                const paths = self.changedPaths;
                self.changed = false;
                self.changedPaths = [];
                self.callback(paths);
            }
            return result;
        };
    }
    wrapTraps(traps) {
        return {
            get: this.wrapTrap(traps.get),
            set: this.wrapTrap(traps.set),
            defineProperty: this.wrapTrap(traps.defineProperty),
            deleteProperty: this.wrapTrap(traps.deleteProperty),
            apply: this.wrapTrap(traps.apply)
        };
    }
}
/* EXPORT */
exports.default = TrapsHelpers;
